import { render, staticRenderFns } from "./RankTemplate.vue?vue&type=template&id=dfbd012c&scoped=true"
import script from "./RankTemplate.vue?vue&type=script&lang=js"
export * from "./RankTemplate.vue?vue&type=script&lang=js"
import style0 from "./RankTemplate.vue?vue&type=style&index=0&id=dfbd012c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbd012c",
  null
  
)

export default component.exports